import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { useTranslation } from 'core/i18n/i18n';
import { SettingsFullWidthContentLayout } from 'modules/settings/components/settings-fullwidth-content-layout/settings-fullwidth-content-layout.component';
import { settingsModulePaths } from 'core/routes/routes';
import { usePopupManager } from 'react-popup-manager';
import { useNavigate } from 'react-router-dom';
import { SettingsDevicesEapSettingsBulkActionsContainer } from '../settings-devices-eap-settings-bulk-actions/settings-devices-eap-settings-bulk-actions.container';
import { EapSettingsImportModalComponent } from '../settings-devices-eap-settings-import-modal/settings-devices-eap-settings-import-modal.component';
import { EapSettingsImportFlowData } from '../settings-devices-eap-settings-import-modal/settings-devices-eap-settings-import-modal.model';
import { SettingsDevicesEapSettingsListContainer } from '../settings-devices-eap-settings-list/settings-devices-eap-settings-list.container';

export const SettingsDevicesEapSettingsContainer = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const popupManager = usePopupManager();

    const handleAddEapSettings = () => {
        navigate('new');
    };

    const handleImportEapSettings = () => {
        const handleContinueImport = (importFlowData: EapSettingsImportFlowData) => {
            navigate(`${settingsModulePaths.eapSettings}/importing`, {
                state: importFlowData,
            });
        };

        popupManager.open(EapSettingsImportModalComponent, {
            onContinueImport: handleContinueImport,
        });
    };

    return (
        <SettingsFullWidthContentLayout
            title={t('settings.devices.eap-settings.eap-config-list.title')}
            description={t('settings.devices.eap-settings.eap-config-list.subtitle')}
            actionsContent={
                <>
                    <PocButton variant="secondary" onClick={handleAddEapSettings}>
                        {t('settings.devices.eap-settings.eap-config-list.action.add')}
                    </PocButton>
                    <PocButton variant="secondary" onClick={handleImportEapSettings}>
                        {t('settings.devices.eap-settings.eap-config-list.action.import')}
                    </PocButton>
                </>
            }
            extraContent={<SettingsDevicesEapSettingsBulkActionsContainer />}
        >
            <SettingsDevicesEapSettingsListContainer />
        </SettingsFullWidthContentLayout>
    );
};
